import { ChangeDetectionStrategy, Component, computed, HostListener, inject, signal } from '@angular/core';
import { LightboxService } from './lightbox.service';

@Component({
  selector: 'k-lightbox',
  standalone: true,
  imports: [],
  templateUrl: './lightbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LightboxComponent {
  private lightboxService = inject(LightboxService);

  isVisible = this.lightboxService.isVisible;
  imageUrl = this.lightboxService.imageUrl;
  altText = this.lightboxService.altText;
  images = this.lightboxService.images;
  currentIndex = this.lightboxService.currentIndex;
  imageLoaded = signal(false);

  hasMultipleImages = computed(() => this.images().length > 1);

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.closeLightbox();
  }

  @HostListener('document:keydown.arrowleft')
  onArrowLeft(): void {
    if (this.isVisible() && this.hasMultipleImages()) {
      this.previous();
    }
  }

  @HostListener('document:keydown.arrowright')
  onArrowRight(): void {
    if (this.isVisible() && this.hasMultipleImages()) {
      this.next();
    }
  }

  closeLightbox(): void {
    this.imageLoaded.set(false);
    this.lightboxService.close();
  }

  next(): void {
    this.imageLoaded.set(false);
    this.lightboxService.next();
  }

  previous(): void {
    this.imageLoaded.set(false);
    this.lightboxService.previous();
  }

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.closeLightbox();
    }
  }

  onImageLoad(): void {
    this.imageLoaded.set(true);
  }
}
